var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 5.33337C17.4147 5.33337 18.7712 5.89528 19.7714 6.89547C20.7716 7.89566 21.3335 9.25222 21.3335 10.6667C21.3335 12.0812 20.7716 13.4377 19.7714 14.4379C18.7712 15.4381 17.4147 16 16.0002 16C14.5857 16 13.2291 15.4381 12.2289 14.4379C11.2287 13.4377 10.6668 12.0812 10.6668 10.6667C10.6668 9.25222 11.2287 7.89566 12.2289 6.89547C13.2291 5.89528 14.5857 5.33337 16.0002 5.33337ZM16.0002 18.6667C21.8935 18.6667 26.6668 21.0534 26.6668 24V26.6667H5.3335V24C5.3335 21.0534 10.1068 18.6667 16.0002 18.6667Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGinfo);
export default __webpack_public_path__ + "static/media/ginfo.2711ff4bc18e19d41ba5530f7a1748d1.svg";
export { ForwardRef as ReactComponent };